import angular from 'angular';
import { AccordionComponent } from './accordion.component';
import { AccordionItemComponent } from './accordion-item.component';

export const AccordionModule = angular
  .module('app.components.accordion', [])
  .component('updAccordion', AccordionComponent)
  .component('updAccordionItem', AccordionItemComponent);
